import {useMemo} from "react";
import {useLocation, useNavigate, useSearchParams} from "react-router";

type Router = {
    gotoHome: () => void
    gotoLogin: () => void
    gotoRegister: () => void
    gotoRegisterConfirm: () => void
    gotoResetPassword: () => void
    gotoResetPasswordConfirm: () => void
    gotoChangePassword: () => void
    gotoMemorial: (id: string) => void
    gotoRedirect: () => boolean
}

export const useRouter = (): Router => {
    const navigate = useNavigate()
    const location = useLocation()
    const [searchParams] = useSearchParams();
    return useMemo((): Router => ({
        gotoHome: () => navigate("/"),
        gotoLogin: () => navigate(`/login?redirect=${encodeURIComponent(location.pathname)}`),
        gotoRegister: () => navigate("/register"),
        gotoRegisterConfirm: () => navigate("/register/confirm"),
        gotoResetPassword: () => navigate("/reset-password"),
        gotoResetPasswordConfirm: () => navigate("/reset-password/confirm"),
        gotoChangePassword: () => navigate("/change-password"),
        gotoMemorial: (id: string) => navigate("/" + id),
        gotoRedirect: (): boolean => {
            const redirectTo = searchParams.get("redirect")
            if (!redirectTo) {
                return false
            }
            navigate(decodeURIComponent(redirectTo))
            return true
        }
    }), [navigate, location, searchParams])
}
